module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.aded3ae5.jpg";